import axiosInstance from "../utils/axiosInstance";

export const fetchGroups = async () => {
    try {
        const response = await axiosInstance.get(`/api/groups`);
        return response.data.data;
    } catch (error) {
        console.error('Error fetching groups:', error);
        return [];
    }
};

const getGroupsOrderMap = () => {
    try {
        const stored = JSON.parse(localStorage.getItem('groups')) || [];
        return new Map(stored.map((g) => [g.uid, g.order]));
    } catch (err) {
        console.error('Failed to parse groups from localStorage', err);
        return new Map();
    }
};

export const groupByGroups = (data) => {
    const groupMap = new Map();
    const WITHOUT_GROUP_ID = '__without_group__';
    const orderMap = getGroupsOrderMap();

    for (const item of data) {
        if (item.groups.length === 0) {
            if (!groupMap.has(WITHOUT_GROUP_ID)) {
                groupMap.set(WITHOUT_GROUP_ID, {
                    uid: WITHOUT_GROUP_ID,
                    title: 'Without Group',
                    order: null,
                    items: [],
                });
            }
            groupMap.get(WITHOUT_GROUP_ID).items.push(item);
        } else {
            for (const group of item.groups) {
                if (!groupMap.has(group.uid)) {
                    groupMap.set(group.uid, {
                        uid: group.uid,
                        title: group.title,
                        order: orderMap.has(group.uid)
                            ? orderMap.get(group.uid)
                            : group.order,
                        items: [],
                    });
                }
                groupMap.get(group.uid).items.push(item);
            }
        }
    }

    const result = [];
    for (const [key, value] of groupMap) {
        if (key !== WITHOUT_GROUP_ID) result.push(value);
    }

    // null order first, then ascending order
    result.sort((a, b) => {
        if (a.order === null && b.order === null) return 0;
        if (a.order === null) return -1;
        if (b.order === null) return 1;
        return a.order - b.order;
    });

    // "Without Group" always last
    if (groupMap.has(WITHOUT_GROUP_ID)) {
        result.push(groupMap.get(WITHOUT_GROUP_ID));
    }

    return result;
};